import { logToSentry } from '@/src/lib/logger/business/sentry-logger';

export function handleException(error: Error | unknown, message?: string) {
  logToSentry(error, message);

  // eslint-disable-next-line no-console
  console.error(error);
}
